<template>
  <div class="message-queue-table" v-loading="loading">
    <!-- button group-->
    <div class="mb-x2" layout="layout" layout-align="space-between-end">
      <div layout="layout" layout-align="start-end">
        <div class="mr-x1">
          <el-button class="el-button-mt" type="primary" @click="changeTab('queue-create', null)"
            ><i class="mdi mdi-plus"></i>一括配信メッセージの新規作成</el-button
          >
        </div>
      </div>
    </div>
    <!-- table-->
    <el-table class="mb-x2" :data="queues" stripe @header-click="headerClick">
      <el-table-column label="対象メッセージ" sort-by="-name" :render-header="renderHeader" min-width="18%">
        <template slot-scope="scope">{{ scope.row.message ? scope.row.message.name : '全てのメッセージ' }}</template>
      </el-table-column>
      <el-table-column label="ステータス" sort-by="-status" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">
          <div class="text-info" v-if="scope.row.status === 'scheduled'">スケジュール済み</div>
          <div class="text-primary" v-if="scope.row.status === 'sending'">
            <template v-if="scope.row.isSendStop">配信中(停止中)</template>
            <template v-else>配信中</template>
          </div>
          <div class="text-primary" v-if="scope.row.status === 'paused'">
            <template v-if="scope.row.isSendStop">停止中</template>
            <template v-else>一時停止</template>
          </div>
          <div class="text-success" v-if="scope.row.status === 'sent'">
            <template v-if="scope.row.isSendStop">配信済み(配信停止)</template>
            <template v-else>配信済み</template>
          </div>
          <div class="text-disabled" v-if="scope.row.status === 'draft'">下書き</div>
        </template>
      </el-table-column>
      <el-table-column label="種別" sort-by="-type" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope"
          ><span v-if="scope.row.type === 0">当選通知</span><span v-if="scope.row.type === 2">リマインド</span
          ><span v-if="scope.row.type === 3">シリアルコード未使用のリマインド</span
          ><span v-if="scope.row.type === 4">配信失敗した応募者への再配信</span></template
        >
      </el-table-column>
      <el-table-column label="配信開始日時" sort-by="-actionDatetime" :render-header="renderHeader" min-width="17%">
        <template slot-scope="scope">
          <div>{{ formatDate(scope.row.actionDatetime) }}</div>
          <div>{{ formatTime(scope.row.actionDatetime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="配信予定数" min-width="10%">
        <template slot-scope="scope">{{ scope.row.scheduleCount }}</template>
      </el-table-column>
      <el-table-column label="配信結果" min-width="10%">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'scheduled' || scope.row.status === 'draft'">-</div>
          <div v-else>
            <div>{{ scope.row.sentCount }}</div>
            <div>{{ '失敗' }}: {{ scope.row.failedCount }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="20%">
        <template slot-scope="scope">
          <el-tooltip :enterable="false" placement="top" content="配信履歴">
            <el-button
              class="el-button--icon"
              type="default"
              v-show="scope.row.status === 'sending' || scope.row.status === 'sent' || scope.row.status === 'paused'"
              @click="changeTab('queue-message-table', scope.row.id)"
              ><i class="mdi mdi-playlist-play"></i
            ></el-button>
          </el-tooltip>
          <el-tooltip :enterable="false" placement="top" content="配信対象">
            <el-button
              class="el-button--icon"
              type="default"
              v-show="scope.row.status === 'draft' || scope.row.status === 'scheduled'"
              @click="changeTab('message-queue-targets', scope.row.id)"
              ><i class="mdi mdi-playlist-play"></i
            ></el-button>
          </el-tooltip>
          <el-tooltip :enterable="false" placement="top" content="編集">
            <el-button class="el-button--icon" type="default" @click="changeTab('queue-create', scope.row.id)"
              ><i class="mdi mdi-table-edit"></i
            ></el-button>
          </el-tooltip>
          <el-tooltip :enterable="false" placement="top" content="配信停止">
            <el-button
              class="el-button--icon"
              type="default"
              v-show="scope.row.status === 'sending' || scope.row.status === 'paused'"
              :disabled="scope.row.isSendStop === 1 || isSubmit"
              @click="stopSend(scope.row.id)"
              ><i class="mdi mdi-cancel"></i
            ></el-button>
          </el-tooltip>
          <el-tooltip :enterable="false" placement="top" content="削除">
            <el-button
              class="el-button--icon"
              type="default"
              v-show="scope.row.status === 'draft' || scope.row.status === 'scheduled'"
              @click="deleteQueue(scope.row.id)"
              ><i class="mdi mdi-delete"></i
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-queue-table {
  .el-button + .el-button {
    margin-left: $spacing-unit;
  }

  .el-button {
    margin-left: $spacing-unit;
  }
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import Util from '@/client/core/util'
import { formatDate, formatTime } from '@/client/filters/filters'
import { useTwitterInstantwinQueueStore } from '@/client/store/useTwitterInstantwinQueueStore'

export default defineComponent({
  data() {
    return {
      isSubmit: false
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinQueueStore, {
      queues: state => state.queues.list,
      params: state => state.queues.params,
      loading: state => state.loading
    })
  },
  async mounted() {
    const params = {
      campaignId: this.$route.params.campaignId
    }

    await this.setQueueListParams(params)
  },
  watch: {
    params() {
      this.fetchQueueList()
    }
  },
  methods: {
    formatDate,
    formatTime,

    ...mapActions(useTwitterInstantwinQueueStore, ['fetchQueueList', 'setQueueListParams', 'setQueueMessageId']),

    /**
     * メッセージキューの削除
     * @param {number} queueId
     */
    async deleteQueue(queueId: number) {
      const confirm = window.confirm('メッセージ配信スケジュールを削除してもよろしいですか?')

      if (!confirm) {
        return
      }

      const result = await api.delete('/twitter_instantwin_queues/' + queueId)

      // 対象キャンペーンレコードが存在しない場合
      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象のメッセージ配信スケジュールはすでに削除されています。',
          message: '',
          customClass: 'danger',
          duration: 5000
        })

        await this.fetchQueueList()

        return
      }

      // 削除に失敗した場合
      if (!result.data) {
        this.$notify({
          title: 'メッセージ配信スケジュールの削除に失敗しました。',
          message: '恐れ入りますが、時間を置いて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })

        return
      }

      // 削除に成功した場合
      this.$notify({
        title: 'メッセージ配信スケジュールを削除しました。',
        message: '',
        customClass: 'success',
        duration: 5000
      })

      await this.fetchQueueList()
    },

    /**
     * Change screen
     * @param {string} tab
     * @param {number} queueId
     */
    changeTab(tab: string, queueId: number) {
      this.$emit('change_tab', tab)
      this.setQueueMessageId(queueId)
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      if (this.params.sortBy === sortBy) {
        return
      }

      this.setQueueListParams({ sortBy })
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (!column.sortBy) {
        return
      }

      if (column.sortBy.indexOf('-') === 0) {
        if (this.params.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.params.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.params.sortBy, column.sortBy),
        !!column.sortBy
      )
    },

    /**
     * 配信停止
     * @param {number} queueId
     */
    async stopSend(queueId: number) {
      let message = `${'メッセージの配信を停止してもよろしいですか？'}\n`
      message += '配信停止の取り消しは行なえません。'

      const confirm = window.confirm(message)

      if (!confirm) {
        return
      }

      this.isSubmit = true

      let messageId = null
      const queue = await api.get(`/twitter_instantwin_queues/${queueId}`)

      if (queue && queue.data) {
        messageId = queue.data.messageId
      }

      const response = await api.put(`/twitter_instantwin_queues/${queueId}`, {
        campaignId: this.params.campaignId,
        messageId,
        isSendStop: 1
      })

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (!response.data || !queue.data) {
        this.$notify({
          title: '配信停止に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })

        return
      }

      this.$notify({
        title: 'メッセージを配信停止しました。',
        message: '配信停止まで、5分ほどかかる場合がございます。',
        customClass: 'success',
        duration: 5000
      })

      await this.fetchQueueList()
    }
  }
})
</script>
